import React from "react";
import { Modal } from '@mantine/core';
import S from './PartnersModal.module.scss'
import {partnersData} from "../../shared/mock/partners";
import {GazTechnologies, MonitorElectric} from "../../pages/partner-card/additionalnformation";

interface ModalProps {
    opened: boolean;
    close: () => void;
    idPartners: any;
}

export const PartnersModal = ({
    opened,
    close,
    idPartners,
}: ModalProps) => {
    const partner = partnersData.find((item) => item.id.toString() === idPartners);
    return (
        <Modal.Root
            opened={opened}
            onClose={close}
            size="xl"
            centered
            zIndex={305}
        >
            <Modal.Overlay zIndex={304} />
            <Modal.Content>
                <Modal.Header className={S.header}>
                    <Modal.Title className={S.title}>{partner?.title}</Modal.Title>
                    <Modal.CloseButton />
                </Modal.Header>
                <Modal.Body className={S.body}>
                    <div className={S.mainLayout}>
                        <div className={S.sidebar}>
                            <div className={S.card}>
                                <img src={partner?.images} alt={partner?.title}/>
                            </div>
                            <div className={S.contacts}>
                                {partner?.site && (
                                    <a href={partner?.site} target="_blank" rel="noreferrer">
                                        {partner?.site}
                                    </a>
                                )}
                                {partner?.email && (
                                    <a href={`mailto:${partner?.email}`}>
                                        {partner?.email}
                                    </a>
                                )}
                                {partner?.phone && (
                                    <a href={`tel:${partner?.phone.replace(/\s/g, '')}`}>
                                        {partner?.phone}
                                    </a>
                                )}
                            </div>
                        </div>

                        <div className={S.info}>
                            <div className={S.description}>
                                {partner?.description.map((text, index) => (
                                    <p key={index}>{text}</p>
                                ))}
                                {partner?.infoMonitorElectric && <MonitorElectric/>}
                                {partner?.infoGazTechnologies && <GazTechnologies/>}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
};